/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliAdminDtoApiResponse } from '../../models/amoxcalli-admin-dto-api-response';
import { AmoxcalliRegisterAdminDto } from '../../models/amoxcalli-register-admin-dto';

export interface ApiAuthRegisterAdminPost$Plain$Params {
      body?: AmoxcalliRegisterAdminDto
}

export function apiAuthRegisterAdminPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAuthRegisterAdminPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliAdminDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAuthRegisterAdminPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliAdminDtoApiResponse>;
    })
  );
}

apiAuthRegisterAdminPost$Plain.PATH = '/api/auth/register/admin';
